import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch } from 'react-redux';
import { signOutSuccess } from '../../../redux/admin/adminSlice';
import Constants from '../../../App.constants';

function SidebarComponent() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSignout = async () => {
        try {
            const res = await fetch(Constants.API_URL+'auth/signout', {
                method: "POST",
            });
            const data = await res.json();
            if (res.ok) {
                dispatch(signOutSuccess());
                navigate('/admin'); // Redirect to the admin page after successful sign-out
            } else {
                console.log('Sign out failed:', data.message);
            }
        } catch (error) {
            console.log('Error signing out:', error.message);
        }
    };

    useEffect(() => {
        const urlPath = window.location.pathname;
        const parts = urlPath.split('/');
        const lastWord = parts[parts.length - 1];
        const element = document.getElementsByClassName(lastWord)[0];
        if (element) {
            element.classList.add('active');
        }
    }, []);

    const navigateTo = (path) => {
        navigate(`/admin/${path}`);
    };

    return (
        <div className="d-flex flex-column flex-shrink-0 p-3 text-bg-light h-100" style={{ borderRight: "1px solid black" }}>
            <a href="/" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-dark text-decoration-none">
                <span className="fs-4">
                    <img src="data:image/png;base64,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" alt="" />
                </span>
            </a>
            <hr />
            <ul className="nav nav-pills flex-column mb-auto">
                <li className="nav-item">
                    <button onClick={() => { navigateTo('reservation') }} className="w-100 text-start nav-link text-dark reservation" aria-current="page">
                        Reservation
                    </button>
                </li>
            
                <li>
                    <button onClick={() => { navigateTo('contact') }} className="w-100 text-start nav-link text-dark contact">
                        Contact
                    </button>
                </li>
            </ul>
            <hr />
               
            <button  onClick={handleSignout}>Sign out</button>
          
        </div>
    );
}

export default SidebarComponent;
